// extracted by mini-css-extract-plugin
module.exports = {"tag":"index-module_tag_v9Z1x"};